import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
   MDBPagination,
   MDBPaginationItem,
   MDBPaginationLink,
   MDBTable,
   MDBTableHead,
   MDBTableBody,
} from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";

import ComptableContext from "../../../context/ComptableContext";
import Button from "react-bootstrap/Button";
import Updateapp from "./Updateapp";
import ConfirmPopup from "../../../updateAndDeleteButtons/ConfirmPopup";
import Bar from "../../../loading/Bars/Bar_loding";

const Gps = () => {
   const {
      is_sending,
      getAllAppareilsForComtaple,
      AllApparielForComtple,
      handleAffectedArticleOption,
      handleSubmittedToTechnician,
      handleConfirmAction,
      updateDeviceSubmit,
      errorMessage,
   } = useContext(ComptableContext);

   useEffect(() => {
      getAllAppareilsForComtaple();
   }, []);

   const Navigate = useNavigate();
   const [selectedAppareils, setSelectedAppareils] = useState(null);
   const [rowClick, setRowClick] = useState(true);

   useEffect(() => {
      if (selectedAppareils != null) {
         const appareilsId = selectedAppareils.map((appareil) => appareil.id);
         handleAffectedArticleOption(appareilsId);
      }
   }, [selectedAppareils]);

   useEffect(() => {
      setSelectedAppareils(null);
   }, [AllApparielForComtple.getAllGPSComptable]);

   const [globalFilterValue, setGlobalFilterValue] = useState("");

   const [filters, setFilters] = useState({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      serial_number: { value: null },
      nameModele: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      nameType: { value: null, matchMode: FilterMatchMode.IN },
      numberBox: { value: null, matchMode: FilterMatchMode.IN },
   });

   const onGlobalFilterChange = (e) => {
      const value = e.target.value;
      let _filters = { ...filters };

      _filters["global"].value = value;

      setFilters(_filters);
      setGlobalFilterValue(value);
   };

   // table appareil pre user

   const [pages, setPagesAppareilPreUser] = useState(1);
   const [rowsPrePage, setRowsPrePage] = useState(5);
   const lastAppareilIndex = pages * rowsPrePage;
   const firstAppareilIndex = lastAppareilIndex - rowsPrePage;
   const currentAppareilPreUser = AllApparielForComtple?.gpsUserAssociate?.slice(
      firstAppareilIndex,
      lastAppareilIndex
   );

   let numberPagesAppareilPreUser = [];
   for (
      let p = 1;
      p <= Math.ceil(AllApparielForComtple.gpsUserAssociate.length / rowsPrePage);
      p++
   ) {
      numberPagesAppareilPreUser.push(p);
   }
   const renderHeader = () => {
      return (
         <div className="flex justify-content-end">
            <span className="p-input-icon-left">
               <i className="pi pi-search" />
               <InputText
                  value={globalFilterValue}
                  onChange={onGlobalFilterChange}
                  placeholder="Keyword Search"
               />
            </span>
         </div>
      );
   };
   const header = renderHeader();

   const renderUpdateAndDeleteAppareil = (rowDate) => {
      return (
         <>
            <div style={{ display: "flex" }}>
               <Updateapp updateFunction={updateDeviceSubmit} data={rowDate} />
               <ConfirmPopup
                  message="Etes vous sûre de vouloir supprimer cette article?"
                  id={rowDate.id}
                  deleteFunction={(e) => handleConfirmAction(rowDate.id)}
               />
            </div>
         </>
      );
   };

   return (
      <div
         style={{
            width: "90%",
            padding: "2rem",
            marginTop: "1rem",
            marginLeft: "50px",
            borderRadius: "2rem",
         }}
      >
         <div
            style={{
               backgroundColor: "white",
               width: "90%",
               padding: "2rem",
               marginLeft: "50px",
               marginTop: "1rem",
               borderRadius: "2rem",
            }}

         >
            <div className="bar-table" style={{ padding: "0rem 2rem 1rem 2rem " }}>
               <div>
                  <h3>
                     GPS &nbsp; <span class="vl"></span> &nbsp;{" "}
                     <span style={{ fontSize: "20px" }}>
                        {AllApparielForComtple.getAllGPSComptable.length} Unités
                     </span>
                  </h3>
               </div>
            </div>
            <DataTable
               value={AllApparielForComtple.getAllGPSComptable}
               selectionMode={rowClick ? null : "checkbox"}
               selection={selectedAppareils}
               onSelectionChange={(e) => setSelectedAppareils(e.value)}
               dataKey="id"
               header={header}
               paginator
               sortMode="multiple"
               filters={filters}
               rows={10}
               rowsPerPageOptions={[10, 25, 50, 100]}
               globalFilterFields={[
                  "serial_number",
                  "nameModele",
                  "nameType",
                  "numberBox",
               ]}
               tableStyle={{ minWidth: "50rem" }}
            >
               <Column
                  header="#"
                  headerStyle={{ width: "3rem" }}
                  body={(data, options) => options.rowIndex + 1}
                  bodyStyle={{ fontWeight: "bold" }}
               ></Column>
               <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "3rem" }}
               ></Column>
               <Column field="serial_number" header="IMEI"></Column>
               <Column field="nameModele" header="Model"></Column>
               <Column field="nameType" header="Marque"></Column>
               <Column field="numberBox" header="Box"></Column>
               <Column header="Action" body={renderUpdateAndDeleteAppareil}></Column>
            </DataTable>
            {errorMessage && errorMessage.Articles ? (
               <span style={{ color: "red" }}>select appareil(s)</span>
            ) : (
               ""
            )}
            <div
               style={{
                  display: "flex",
                  // flexDirection: "column",
                  width: "25%",
                  gap: "20px",
                  padding: "2rem",
               }}
            >

               {is_sending === "affectedGPS" ? (
                  <Bar />
               ) : (
                  <Button
                     accessKey="affectedGPS"
                     type="submit"
                     variant="primary"
                     disabled={selectedAppareils == null}
                     onClick={(e) => handleSubmittedToTechnician(e)}
                  >
                     Transfert à support technique
                  </Button>
               )
               }
            </div>
         </div>
         <div style={{ display: "flex", justifyContent: "center" }}>
            <div
               style={{
                  backgroundColor: "white",
                  width: "80%",
                  padding: "2rem",
                  marginTop: "1rem",
                  borderRadius: "2rem",
               }}
            >
               <MDBTable align="middle">
                  <MDBTableHead>
                     <tr>
                        <th scope="col"></th>
                        <th scope="col">Utilisateur</th>
                        <th scope="col">Quantité</th>
                        <th scope="col">Appareils</th>
                     </tr>
                  </MDBTableHead>
                  {currentAppareilPreUser.map((appareilPreUser, index) => (
                     <MDBTableBody>
                        <tr key={index}>
                           <td>
                              <div className="d-flex align-items-center"></div>
                           </td>
                           <td>
                              <p className="fw-normal mb-1">{appareilPreUser.name}</p>
                           </td>

                           <td>
                              <p className="fw-normal mb-1">
                                 {appareilPreUser.numberArticle}
                              </p>
                           </td>
                           <td>
                              <Button
                                 className="showAppareilPreUser"
                                 variant="primary"
                                 onClick={() =>
                                    Navigate(
                                       `/comptable/appareils-pour-l'utilisateur/${appareilPreUser.id}/GPS`
                                    )
                                 }
                              >
                                 voir les appareils
                              </Button>
                           </td>
                        </tr>
                     </MDBTableBody>
                  ))}
               </MDBTable>
               {AllApparielForComtple.gpsUserAssociate.length > 0 ? (
                  <nav aria-label="...">
                     <MDBPagination className="mb-0 d-flex justify-content-end">
                        <MDBPaginationItem disabled>
                           <MDBPaginationLink
                              href="#"
                              tabIndex={-1}
                              aria-disabled="true"
                           >
                              Pages
                           </MDBPaginationLink>
                        </MDBPaginationItem>
                        {numberPagesAppareilPreUser.map((numberPage, index) => (
                           <MDBPaginationItem
                              key={index}
                              className={`${numberPage == pages ? "active" : "null"}`}
                           >
                              <MDBPaginationLink
                                 style={{ cursor: "pointer" }}
                                 onClick={() => setPagesAppareilPreUser(numberPage)}
                              >
                                 {numberPage}
                              </MDBPaginationLink>
                           </MDBPaginationItem>
                        ))}
                     </MDBPagination>
                  </nav>
               ) : (
                  ""
               )}
            </div>
         </div>
      </div>
   );
};

export default Gps;
